module.exports = __webpack_public_path__ + "static/img/eb-bg.5b368ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/customisation/eb-bg.png
// module id = p110
// module chunks = 1